export const REELS_CREATOR_TOOL_ID = 'reels-creator';

// The platform-api app registry lists the hosted Reels Creator as `content-studio`, the name it
// shipped under. It is not the in-app Content Studio, whose tool id happens to be the same string.
export const REELS_CREATOR_APP_SLUG = 'content-studio';

/**
 * Opens the hosted Reels Creator on the current workspace. Without `workspaceId` it falls
 * back to the user's default workspace, which hides everything made under another one.
 */
export const openReelsCreatorTool = (hostedUrl: string, workspaceId: string): void => {
  const url = new URL(hostedUrl);
  url.searchParams.set('workspaceId', workspaceId);
  window.open(url.toString(), '_self');
};
